import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { EModalName } from '../../../types/enums'
import { Button, Scrollable } from '../../atoms'
import { ButtonHoldToConfirm } from '../../molecules'
import { TableHostSettings } from '../../molecules/TableHostSettings'
import type { PrivateTableSettingsType } from '../CreatePrivateTable/types'
import {
  basement,
  button,
  drawerContainer,
  scrollableContent,
} from './index.css'

export const TableMenuAdminSettings = (props: {
  tableId: string
  playersCount: number
  close: (result: PrivateTableSettingsType | null) => void
}) => {
  const { t } = useTranslation()
  const privateTableSettings = useRef<PrivateTableSettingsType | null>(null)

  return (
    <div className={drawerContainer}>
      <Scrollable className={scrollableContent}>
        <TableHostSettings
          tableId={props.tableId}
          playersCount={props.playersCount}
          onChange={(data) => {
            privateTableSettings.current = data
          }}
        />
      </Scrollable>

      <div className={basement}>
        <Button
          className={button}
          variant='bordered'
          analytic={{
            name: 'cancel',
            params: {
              modal: EModalName.TABLE_ADMIN_SETTINGS,
            },
          }}
          onClick={() => props.close(null)}
        >
          {t('modal.tableSettings.button.cancel')}
        </Button>
        <ButtonHoldToConfirm
          className={button}
          variant='primary'
          disabled={!!privateTableSettings.current}
          analytic={{
            name: 'apply',
            params: {
              modal: EModalName.TABLE_ADMIN_SETTINGS,
            },
          }}
          onConfirm={() => props.close(privateTableSettings.current)}
        >
          {t('modal.tableSettings.button.apply')}
        </ButtonHoldToConfirm>
      </div>
    </div>
  )
}
